import {
  clearImportJourneySummary,
  importJourneySummaryFail,
  importJourneySummaryStarted,
  importJourneySummarySuccess
} from '../../reducer/ImportJourneySummaryReducer';
import { postImportJourneySummary } from '../actionType/ImportJourneySummaryActionType';
import {
  ClearImportJourneySummary,
  FetchImportJourneySummaryFailPayload,
  FetchImportJourneySummaryFailure,
  FetchImportJourneySummaryRequest,
  FetchImportJourneySummaryStarted,
  FetchImportJourneySummarySuccess,
  FetchImportJourneySummarySuccessPayload,
} from '../types/ImportAllJourneySummaryTypes';

export const fetchImportServiceSummaryRequest = (fileData: FormData): FetchImportJourneySummaryRequest => ({
  type: postImportJourneySummary.POST_IMPORT_JOURNEY_SUMMARY_REQUEST,
  fileData
});

/**
 * Fetch schema started saga action
 * @returns schema started action
 */
export const fetchImportJourneySummaryStarted = (): FetchImportJourneySummaryStarted => ({
  type: importJourneySummaryStarted.type
});

/**
 * Fetch schema success saga action
 * @param payload :schema data
 * @returns success action
 */
export const fetchImportJourneySummarySuccess = (
  payload: FetchImportJourneySummarySuccessPayload
): FetchImportJourneySummarySuccess => ({
  type: importJourneySummarySuccess.type,
  payload
});

/**
 * Fetch Schema Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const fetchImportJourneySummaryFailure = (
  payload: FetchImportJourneySummaryFailPayload
): FetchImportJourneySummaryFailure => ({
  type: importJourneySummaryFail.type,
  payload
});

/**
 * Clear Schema saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const clearImportJourneySummarys = (): ClearImportJourneySummary => ({
  type: clearImportJourneySummary.type
});
